<template>
  <section class="contentWrap">
    <transition-group
      name="slide-fade"
      mode="out-in"
    >
      <debitos :key="step" v-if="step == 'debitos'" :session="session" :step="current" :debitos="debitos" />
      <pagamento :key="step" v-if="step == 'pagamento'" :session="session" :step="current" :debitos="debitos" />
    </transition-group>
  </section>
</template>

<script>
import Debitos from '@/components/financeiro/negocieja/app/template/Debitos.vue'
import Pagamento from '@/components/financeiro/negocieja/app/template/Pagamento.vue'

export default {
  components: {
    Debitos, Pagamento
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    steps: {
      type: Array
    },
    debitos: {
      type: Object
    }
  },
  data () {
    return {
      current: 'debitos' ,
    }
  },
  mounted () {
    
  },
  methods: {
    next ( data ) {
      console.log('next - data', data)
    },
    prev ( data ) {
      console.log('prev - data', data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .contentWrap {
    flex: 1;
    max-height: calc( 100% - 95px );
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all 0.3s ease;
    position: absolute;
    width: 100%;
  }

  .slide-fade-enter-from {
    transform: translateX(100%);
    opacity: 0;
  }
  .slide-fade-enter-to {
    transform: translateX(0);
    opacity: 1;
  }

  .slide-fade-leave-from {
    transform: translateX(0);
    opacity: 1;
  }
  .slide-fade-leave-to {
    transform: translateX(-100%);
    opacity: 0;
  }

  .contentWrap {
    position: relative;
    overflow: hidden;
    min-height: 200px; // or your content's height
  }
</style>